/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * Feedback Rating Display Component
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

import React from 'react'
import { Star } from 'lucide-react'

const FeedbackRatingDisplay = ({ rating, showNumber = false, size = 'md' }) => {
  // Default to null if no rating provided
  if (rating === null || rating === undefined) {
    return (
      <span className="text-sm text-gray-500 dark:text-gray-400 italic">No rating provided</span>
    )
  }

  // Ensure rating is between 1-5
  const normalizedRating = Math.max(1, Math.min(5, rating))

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  }

  return (
    <div className="inline-flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          className={`
            ${iconSizes[size]}
            ${
              star <= normalizedRating
                ? 'fill-yellow-400 text-yellow-400'
                : 'text-gray-300 dark:text-gray-600'
            }
          `}
        />
      ))}
      {showNumber && (
        <span className="ml-1 text-sm font-medium text-gray-700 dark:text-gray-300">
          {normalizedRating}/5
        </span>
      )}
    </div>
  )
}

export default FeedbackRatingDisplay
